import styled from '@emotion/styled';

export const ChangePhoneProcedureForm = styled('div', { label: 'ChangePhoneProcedureForm' })`
    margin-top: 8px;
`;

export const InputsWrapper = styled('div', { label: 'InputsWrapper' })`
    display: flex;
`;
